/**
 * Layout fill-mode routes: the shell content pane does not scroll.
 * The routed page fills remaining height (`flex` column) and owns inner scroll.
 *
 * Default (all other authenticated routes):
 *   padding  p-4 lg:p-8  (shell only — pages must not add px-4 / py-6)
 *   max-width  max-w-7xl mx-auto  (shell only — pages must not wrap another max-w-7xl)
 *   scroll    overflow-y-auto on the content pane
 *
 * Fill (`layout-content--fill`):
 *   same padding / max-width
 *   content pane: flex-1 min-h-0 overflow-hidden flex flex-col
 */
const FILL_DOCUMENT_EXCLUSIONS = new Set(['/documents/upload', '/documents/parse']);

export function isLayoutFillRoute(url: string): boolean {
  const path = normalizePath(url);
  if (path === '/templates/create') {
    return true;
  }
  if (/^\/templates\/edit\/[^/]+$/.test(path)) {
    return true;
  }
  if (/^\/documents\/[^/]+$/.test(path) && !FILL_DOCUMENT_EXCLUSIONS.has(path)) {
    return true;
  }
  if (path === '/help' || path.startsWith('/help/')) {
    return true;
  }
  if (path === '/support' || path.startsWith('/support/')) {
    return true;
  }
  return false;
}

function normalizePath(url: string): string {
  const path = url.split('?')[0].split('#')[0];
  if (path.length > 1 && path.endsWith('/')) {
    return path.replace(/\/+$/, '');
  }
  return path;
}
